<ds-card
    msThemedCard
    class="card-wrapper-alignment"
    [themeBorder]="themeBorder"
    [class.card-alignment]="!isEpcotEnabled"
    [border]="!isBorderHidden()">
    @if (crmPromoted) {
        <ms-promotion-badge />
    }
    <ds-accordion
        msThemedAccordion
        variant="surface-high"
        [class.header-alignment]="hideMarketHeader"
        [themedAccordionVariant]="themedAccordionVariant"
        [withCard]="true"
        [open]="!collapsed"
        (openedChange)="!isInSheetView && handleHeaderClick()">
        <ds-accordion-header class="accordion-header-alignment" [interactive]="isInSheetView" [class.header-collapsed]="collapsed">
            <div slot="start" [class.precreated-bab-group-name]="isPrecreatedBuildABet">
                @if (isPrecreatedBuildABet && isPrecreatedBetBuilderBadgeEnabled) {
                    <span class="bet-builder-icon"> {{ sitecore.globalMessages.BetBuilderBadgeText }}</span>
                }
                <div slot="title">
                    @if (showEventName) {
                        <a (click)="goToEvent($event)">
                            {{ event.name }}
                        </a>
                    }
                    @if (customOptionPanelHeaderTemplate()) {
                        <ng-container *ngTemplateOutlet="customOptionPanelHeaderTemplate()" />
                    } @else {
                        {{ optionGroup.name }}
                        @if (!deviceService.isMobile && winMarketName) {
                            {{ winMarketName }}
                        }
                    }
                    @if (showMarketHelpToggle && optionGroup.online && !collapsed && !shouldShowInlineHelpText) {
                        <ms-market-help-toggle
                            [optionGroup]="optionGroup"
                            [event]="event"
                            [selected]="showMarketHelp"
                            (selectedChange)="toggleMarketHelp($event)" />
                    }
                    @if (showPrecreatedBetBuilderNewBadge) {
                        <span class="bet-builder-newbadge"> {{ sitecore.betBuilder.messages?.PrecreatedBuildABetNewBadgeText }}</span>
                    }
                    @if (hasNewBadge()) {
                        <ds-badge size="medium" class="option-group-new-badge" [variant]="newBadgeVariant">
                            {{ sitecore.globalMessages.NewBadgeText }}
                        </ds-badge>
                    }
                </div>
                @if (showEventName) {
                    <div slot="subtitle">
                        @if (showEventTimer && event.scoreboard && event.scoreboard.started) {
                            <i class="live-icon">{{ sitecore.event.Live }}</i>
                        }
                        @if (showEventTimer) {
                            <ms-event-timer class="event-timer" [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
                        }
                    </div>
                }
            </div>
            @if (!customOptionPanelHeaderTemplate()) {
                <div slot="end">
                    <ms-option-panel-header
                        [groupType]="groupType"
                        [optionGroup]="optionGroup"
                        [showHelp]="showHelp"
                        [toggleable]="toggleable && !isInSheetView"
                        [promoted]="promoted"
                        [collapsed]="collapsed"
                        [event]="event"
                        [showEventName]="showEventName"
                        [activePeriodTab]="activePeriodTab"
                        [showEventTimer]="showEventTimer"
                        [isLinkToEvent]="isLinkToEvent"
                        [marketLogoShow]="marketLogoShow"
                        [showEventChevron]="showEventChevron && !isInSheetView"
                        [appendTooltipToWidgetSlot]="appendTooltipToWidgetSlot"
                        [eventHelpText]="eventHelpText"
                        (collapsedChange)="onHeaderToggle($event)"
                        (eventTitleClicked)="onEventTitleClick()"
                        (isBadgeEnabled)="isBadgeclicked()"
                        [(showMarketHelp)]="showMarketHelp" />
                </div>
            }

            <span *dsAccordionTrigger="let isOpen">
                <span class="icon-alignment">
                    @if (!isInSheetView) {
                        @if (!isOpen) {
                            <vn-icon name="theme-down" [size]="isEpcotEnabled ? '16' : '12'" />
                        }
                        @if (isOpen && isEpcotEnabled) {
                            <vn-icon name="theme-up" [size]="isEpcotEnabled ? '16' : '12'" />
                        }
                    } @else {
                        <button ds-button kind="tertiary" variant="outline" size="medium" (click)="onCloseButtonClicked()">
                            {{ sitecore.betBuilderEntainUI.messages?.OverlayClose }}
                        </button>
                    }
                </span>
            </span>
        </ds-accordion-header>

        <ng-template #content>
            <ng-content />
            @if (shouldShowInlineHelpText && !collapsed && !showMarketHelp) {
                <ms-market-help [optionGroup]="activeOptionGroup" [eventHelpText]="eventHelpText" [showInlineInfo]="shouldShowInlineHelpText" />
            }
            <ms-performance-tracker [trigger]="event.id" />
            <ng-container *rxIf="(showSuspendedSelection || optionGroup.online) && !hideOptions(); strategy: strategy$">
                <div class="option-panel-body">
                    @if (customOptionPanelBodyTemplate()) {
                        <ng-container *ngTemplateOutlet="customOptionPanelBodyTemplate(); context: { showMarketHelp: showMarketHelp }" />
                    } @else {
                        @switch (groupType) {
                            @case (groupTypes.PlayerCombined) {
                                <ms-player-combined-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    [showPlayerStats]="showPlayerStats"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.PlayerOutcome) {
                                <ms-player-outcome-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails" />
                            }
                            @case (groupTypes.PlayerMilestone) {
                                <ms-player-milestone-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [isShowTabs]="true"
                                    [scrollAdapterButtonSize]="scrollAdapterButtonSize"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    [showPlayerStats]="showPlayerStats"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.PlayerMilestoneOverUnder) {
                                <ms-player-milestone-over-under-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [isShowTabs]="true"
                                    [scrollAdapterButtonSize]="scrollAdapterButtonSize"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    [showPlayerStats]="showPlayerStats"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.PrecreatedBuildABet) {
                                <ms-precreated-bab-option-group
                                    [event]="event"
                                    [fixtureId]="event.id"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [showMoreCounter]="showMoreCounter"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    [sourceOfPick]="sourceOfPick"
                                    [buttonSource]="babButtonSource"
                                    [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
                                    [hideBetBuilderButton]="hideBetBuilderButton"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.Period) {
                                <ms-period-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [thresholds]="thresholds"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [scrollAdapterButtonSize]="scrollAdapterButtonSize"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    [showSixPackLogosColor]="showSixPackLogosColor"
                                    [showSixPackLogos]="showSixPackLogos"
                                    [showPlayerStats]="showPlayerStats"
                                    (activePeriodChange)="onActivePeriodChange($event)"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.Scorecast) {
                                <ms-scorecast-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [preselectedPick]="preselectedPick"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails" />
                            }
                            @case (groupTypes.Wincast) {
                                <ms-wincast-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails" />
                            }
                            @case (groupType === groupTypes.Regular || groupType === groupTypes.USGroupedList ? groupType : !groupType) {
                                <ms-regular-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [groupType]="groupType"
                                    [thresholds]="thresholds"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [calendarTrack]="calendarTitle"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                                    [eventHelpText]="eventHelpText"
                                    [linkableGroup]="optionGroupLinkable"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    [showPlayerStats]="showPlayerStats"
                                    (expandClicked)="onExpandedClicked($event)"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.CorrectScore) {
                                <ms-correct-score-option-group-wrapper
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [isShowMoreDisabled]="!thresholds && !optionsLimitOverride"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride" />
                            }
                            @case (groupTypes.OverUnder) {
                                <ms-over-under-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.GoalScorer) {
                                <ms-goal-scorer-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [isShowMoreDisabled]="!thresholds && !optionsLimitOverride"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [calendarTrack]="calendarTitle"
                                    [showMarketHelp]="showMarketHelp"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.PlayerProps) {
                                <ms-player-props-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [trackingModuleType]="trackingModuleType"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    [showPlayerStats]="showPlayerStats"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.Spread) {
                                <ms-spread-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [trackingModuleType]="trackingModuleType"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.WincastParticipant) {
                                <ms-wincast-two-way-scorer-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [preselectedPick]="preselectedPick"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [eventHelpText]="eventHelpText"
                                    [trackingModuleType]="trackingModuleType"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails" />
                            }
                            @case (groupTypes.SixPack) {
                                <ms-six-pack-option-group
                                    [event]="event"
                                    [trackingModuleType]="trackingModuleType"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [showLogoColor]="showSixPackLogosColor"
                                    [showSixPackParticipantImages]="showSixPackLogos"
                                    [showPlayerStats]="showPlayerStats" />
                            }
                            @case (groupType === groupTypes.RaceTo || groupType === groupTypes.BTTS ? groupType : !groupType) {
                                <ms-score-market-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [groupType]="groupType"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride" />
                            }
                            @case (groupTypes.Outrights) {
                                <ms-outrights-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [trackingModuleType]="trackingModuleType"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride" />
                            }
                            @case (groupTypes.YesNo) {
                                <ms-yes-no-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    [trackingModuleType]="trackingModuleType"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.TotalScore) {
                                <ms-total-score-option-group
                                    [trackingModuleType]="trackingModuleType"
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride" />
                            }
                            @case (groupTypes.Head2Head) {
                                <ms-head-to-head-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails" />
                            }
                            @case (groupTypes.BetBuilderStandard) {
                                <ms-bet-builder-standard-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick" />
                            }
                            @case (groupTypes.BetBuilderSixPack) {
                                <ms-bet-builder-six-pack
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick" />
                            }
                            @case (groupTypes.BetBuilderOverUnder) {
                                <ms-bet-builder-over-under-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick" />
                            }
                            @case (groupTypes.BetBuilderCorrectScore) {
                                <ms-bet-builder-correct-score-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [isShowMoreDisabled]="!thresholds"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    (showAllRequested)="openSheetView()" />
                            }
                            @case (groupTypes.BetBuilderSpread) {
                                <ms-bet-builder-spread-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick" />
                            }
                            @case (groupTypes.BetBuilderRaceTo) {
                                <ms-bet-builder-teams-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [crmPromoIdsMap]="crmPromoIdsMap"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick" />
                            }
                            @case (groupTypes.BetBuilderGoalScorer) {
                                <ms-bet-builder-goalscorer-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [isShowMoreDisabled]="!thresholds"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick" />
                            }
                            @case (groupTypes.BetBuilderYesNo) {
                                <ms-bet-builder-goalscorer-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [isShowMoreDisabled]="!thresholds"
                                    [tracking]="tracking"
                                    [showMarketHelp]="showMarketHelp"
                                    [trackingModuleType]="trackingModuleType"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick" />
                            }
                            @case (groupTypes.BetBuilderPlayerProps) {
                                <ms-bet-builder-goalscorer-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [isShowMoreDisabled]="!thresholds"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [eventHelpText]="eventHelpText"
                                    [showMarketAttribute]="true"
                                    [sourceOfPick]="sourceOfPick" />
                            }
                            @case (groupTypes.PlayerStats) {
                                <ms-player-stats-option-group
                                    [event]="event"
                                    [optionGroup]="optionGroup"
                                    [tracking]="tracking"
                                    [trackingModuleType]="trackingModuleType"
                                    [showMarketHelp]="showMarketHelp"
                                    [eventHelpText]="eventHelpText"
                                    [sourceOfPick]="sourceOfPick"
                                    [betDetails]="betDetails"
                                    [optionsLimitOverride]="optionsLimitOverride"
                                    (showAllRequested)="openSheetView()" />
                            }
                        }
                    }
                </div>
            </ng-container>
        </ng-template>
    </ds-accordion>
</ds-card>
